import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as React from "react";

import { UnPortaledPopoverContent } from "./unPortaledPopoverContent";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>((props, ref) => (
  <PopoverPrimitive.Portal>
    <UnPortaledPopoverContent {...props} ref={ref} />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverContent, PopoverTrigger };
